/** Convert hex color + opacity to an rgba string (replaces MUI alpha). */
export function hexAlpha(hex: string, opacity: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

/** Lighten a hex color by mixing with white (replaces MUI lighten). */
export function hexLighten(hex: string, coefficient: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgb(${Math.round(r + (255 - r) * coefficient)}, ${Math.round(g + (255 - g) * coefficient)}, ${Math.round(b + (255 - b) * coefficient)})`;
}

/** Build a CSS background value from an array of line colors.
 *  Single color → flat tint; multiple → horizontal gradient. */
export const makeLineGradient = (colors: string[], opacity: number): string => {
    if (colors.length === 0) return 'none';
    if (colors.length === 1) return hexAlpha(colors[0] ?? '#000', opacity);
    return `linear-gradient(90deg, ${colors.map((c, i) => `${hexAlpha(c, opacity)} ${(i / (colors.length - 1)) * 100}%`).join(', ')})`;
};
